import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
    breakpoints: breakpoints,
    mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.callToAction': {
		backgroundColor: getColor('ivory', 400),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: remCalc(616),
		padding: remCalc(30),
		marginBottom: remCalc(50),
		'&.margin-flush': {
			marginBottom: 0,
		},

        [theme.breakpoints.down('md')]: {
            minHeight: remCalc(200),
        },

		'.callToAction__link': {
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(30),
			padding: remCalc(30, 20),
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',
			backgroundColor: getColor('ivory', 400),
			textDecoration: 'none',
			textTransform: 'uppercase',
			color: getColor('ivory', 700),
			[theme.breakpoints.up('md')]: {
				padding: remCalc(60),
			},

			'&:hover': {
				color: getColor('ivory', 700),
				textDecoration: 'none',
			},

			'&:focus-visible': {
				color: getColor('ivory', 700),
				textDecoration: 'none',
			},

			'.callToAction__pre-title': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: 1,
				letterSpacing: '0.5px',
				textTransform: 'uppercase',
				margin: 0,
			},

			'.callToAction__title': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(28),
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: 1,
				letterSpacing: '0.5px',
				textTransform: 'uppercase',
				margin: 0,
				[theme.breakpoints.up('md')]: {
					fontSize: remCalc(49),
		        },
			},

			'.callToAction__body': {
				fontWeight: 500,
				textTransform: 'none',
				[theme.breakpoints.up('md')]: {
					width: '80%',
		        },
		        [theme.breakpoints.down('md')]: {
					fontSize: remCalc(20),
					lineHeight: remCalc(25),
				},
			},

			'.callToAction__linkText': {
				display: 'inline-flex',
				alignItems: 'center',
				borderBottom: '1px solid transparent',
				transition: 'border-color var(--transition-duration) ease',
			},

			'.callToAction__linkText__label': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(20),
				fontStyle: 'normal',
				fontWeight: 420,
				lineHeight: 1.2,
				letterSpacing: '-0.2px',
			},

			'.callToAction__linkText__arrow': {
				width: 0,
				height: remCalc(12),
				opacity: 0,
				marginLeft: 0,
				overflow: 'hidden',
				transform: 'translateX(-6px)',
				transition: 'width  var(--transition-duration) ease, margin-left  var(--transition-duration) ease, opacity  var(--transition-duration-slow) ease, transform  var(--transition-duration) ease',

				'svg': {
					display: 'block',
					width: remCalc(47),
					height: remCalc(12),
				},

				'svg path': {
					fill: getColor('ivory', 700),
				},
			},

			'&:focus-visible .callToAction__linkText': {
				borderBottom: `1px solid ${getColor('ivory', 700)}`,
			},

			'&:focus-visible .callToAction__linkText__arrow': {
				width: remCalc(47),
				marginLeft: remCalc(16),
				opacity: 1,
				transform: 'translateX(0)',
			},

			'@media (hover: hover) and (pointer: fine)': {
				'&:hover .callToAction__linkText': {
					borderBottom: `1px solid ${getColor('ivory', 700)}`,
				},
				'&:hover .callToAction__linkText__arrow': {
					width: remCalc(47),
					marginLeft: remCalc(16),
					opacity: 1,
					transform: 'translateX(0)',
				},
			},
		},
		'@media (prefers-contrast: more)': {
			background: 'white',
			'.callToAction__link': {
				background: 'white',
				color: getColor('ivory', 800),
				'&:hover': {
					color: getColor('ivory', 900),
				},
				'.callToAction__linkText__arrow': {
					'svg path': {
						color: getColor('ivory', 900),
					},
				},
			},

		},
	},
};

export default styles;